<avs-inline-input
  (updated)="onUpdate({ phoneNumber: $event })"
  [disabled]="disabled()"
  [mask]="{ mask: phoneMask(), placeholder: phoneMaskExpression() }"
  [placeholder]="phoneMask()"
  [required]="false"
  [showToast]="false"
  [value]="client().tags['phoneNumber']"
  sizeClass="w-[216px]"
  label="Phone Number"
>
  <avs-country-select
    class="mr-2"
    (changed)="onCountryCodeChange($event)"
    [showPhoneCode]="true"
    [value]="client().tags['countryCode'] || DEFAULT_COUNTRY.code"
  />
</avs-inline-input>
